const _showLogPatches = false

export const logPatches = (component, type, patches, action) => {

  if (!patches.length || !_showLogPatches) return;

  console.group(`🔄 ${component}: State Change via: ${type}`);
  console.log('▶️ action', action);

  patches.forEach(p => {
    console.log(
      `▶️ ${p.op.toUpperCase()} at ${p.path.join(".")}:`,
      p.value
    );
  });
  console.groupEnd()

};

export const logBatch = (batch, dataToUpdate) => {
  console.group('📦logBatch')
  _.forEach(batch?._mutations, (m) => {
    const segments = m?.key?.path?.segments;
    if (segments) {
      const path = segments.join('/');
      console.log('path', path);
    }
  });
  if (dataToUpdate) {
    console.log('dataToUpdate', dataToUpdate)
  }
  console.groupEnd()
}